var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDrag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 3.33333C5.83333 3.79357 6.20643 4.16667 6.66667 4.16667C7.1269 4.16667 7.5 3.79357 7.5 3.33333C7.5 2.8731 7.1269 2.5 6.66667 2.5C6.20643 2.5 5.83333 2.8731 5.83333 3.33333Z",
    stroke: "white",
    strokeWidth: 1.33333
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5001 3.33333C12.5001 3.79357 12.8732 4.16667 13.3334 4.16667C13.7937 4.16667 14.1667 3.79357 14.1667 3.33333C14.1667 2.8731 13.7937 2.5 13.3334 2.5C12.8732 2.5 12.5001 2.8731 12.5001 3.33333Z",
    stroke: "white",
    strokeWidth: 1.33333
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 10.0003C5.83333 10.4606 6.20643 10.8337 6.66667 10.8337C7.1269 10.8337 7.5 10.4606 7.5 10.0003C7.5 9.54009 7.1269 9.16699 6.66667 9.16699C6.20643 9.16699 5.83333 9.54009 5.83333 10.0003Z",
    stroke: "white",
    strokeWidth: 1.33333
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5001 10.0003C12.5001 10.4606 12.8732 10.8337 13.3334 10.8337C13.7937 10.8337 14.1667 10.4606 14.1667 10.0003C14.1667 9.54009 13.7937 9.16699 13.3334 9.16699C12.8732 9.16699 12.5001 9.54009 12.5001 10.0003Z",
    stroke: "white",
    strokeWidth: 1.33333
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 16.6654C5.83333 17.1256 6.20643 17.4987 6.66667 17.4987C7.1269 17.4987 7.5 17.1256 7.5 16.6654C7.5 16.2051 7.1269 15.832 6.66667 15.832C6.20643 15.832 5.83333 16.2051 5.83333 16.6654Z",
    stroke: "white",
    strokeWidth: 1.33333
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5001 16.6654C12.5001 17.1256 12.8732 17.4987 13.3334 17.4987C13.7937 17.4987 14.1667 17.1256 14.1667 16.6654C14.1667 16.2051 13.7937 15.832 13.3334 15.832C12.8732 15.832 12.5001 16.2051 12.5001 16.6654Z",
    stroke: "white",
    strokeWidth: 1.33333
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDrag);
export default __webpack_public_path__ + "static/media/ic-drag.3ad715f312c81877240501ce15f12181.svg";
export { ForwardRef as ReactComponent };